import { mapGetters, mapActions } from "vuex";
import leaveRequests from "@/services/leaveRequest";
import moment from "moment-timezone";
import Utils from "@/mixins/Utils";
import cloneDeep from "lodash/cloneDeep";
import { ALERT_TYPES } from "@/constants/variables";
import { LEAVE_REQUEST_STATUSES,CONDITION_KEY } from "../../constants/variables";
import conditionHelper from "../../helpers/condition";
import { KEYWORDS } from "../../constants/support";
import terminology from "@/mixins/terminology";
import downloadService from "../../services/download";
import date from '../../mixins/date';
moment.tz.setDefault("Europe/Paris");

export default {
  mixins: [Utils, terminology,date],
  computed: {
    ...mapGetters({
      getLeaveRequestSelected: "getLeaveRequestSelected",
      leaveRequestsTypes: "leaveRequestsTypes",
      leaveRequestsStatus: "leaveRequestsStatus",
      leaveRequestStatuses: "leaveRequestStatuses",
    }),

    canBeDeleted() {
      // Validé, Refusé or Validé - En Attente d'Annulation, should not be able to be deleted.
      const canBeDeltedStatuses = [LEAVE_REQUEST_STATUSES.WAIT_FOR_VALIDATION];
      return (
        this.getLeaveRequestSelected &&
        canBeDeltedStatuses.includes(
          this.getLeaveRequestSelected.pkIxLeaveStatut
        ) &&
        this.$route.params.type === "edit"
      );
    },
    editable() {
      const editableStatuses = [LEAVE_REQUEST_STATUSES.WAIT_FOR_VALIDATION];
      return (
        (this.getLeaveRequestSelected &&
          editableStatuses.includes(
            this.getLeaveRequestSelected.pkIxLeaveStatut
          )) ||
        this.$route.params.type === "created"
      );
    },
    cancelable() {
      const cancelableStatuses = [LEAVE_REQUEST_STATUSES.VALIDATED];
      return (
        conditionHelper(CONDITION_KEY.LEAVE_REQUEST_CANCELABLE) &&
        this.getLeaveRequestSelected &&
        cancelableStatuses.includes(
          this.getLeaveRequestSelected.pkIxLeaveStatut
        ) &&
        this.$route.params.type === "edit"
      );
    },
  },

  async created() {
    try {
      if (!this.leaveRequestsTypes.length) {
        await this.fetchLeaveRequestType();
      }
      this.options = this.leaveRequestsTypes;
      if (!this.leaveRequestStatuses.length) {
        this.getLeaveRequestStatuses();
      }
      const queryId = Number(this.$route.params.id);
      if (queryId) {
        if (
          this.getLeaveRequestSelected &&
          queryId === this.getLeaveRequestSelected.pkLeaveRequest
        ) {
          this.leaveRequestToEdit = this.getLeaveRequestSelected;
        } else {
          const { data } = await leaveRequests.getListLeaveRequests();
          this.leaveRequestToEdit = data.find((item) => {
            return item.pkLeaveRequest === Number(this.$route.params.id);
          });
          this.$store.commit("LEAVE_REQUEST_SELECTED", this.leaveRequestToEdit);
        }
        if (
          this.leaveRequestToEdit.filePath &&
          this.leaveRequestToEdit.filePath.length > 0
        ) {
          for(let i = 0; i < this.leaveRequestToEdit.filePath.length; i++) {
            let showImage = false;
            
            if (
              this.leaveRequestToEdit.filePath[i].includes("png") ||
              this.leaveRequestToEdit.filePath[i].includes("gif") ||
              this.leaveRequestToEdit.filePath[i].includes("jpeg") ||
              this.leaveRequestToEdit.filePath[i].includes("svg")
            ) {
              showImage = true;
            }
            if(i===0) {
              this.isShowImage = showImage;
            }else {
              this.isShowSecondImage = showImage;
              
            }
            await this.checkFileExistanceDownload(
              this.leaveRequestToEdit.filePath[i],
              null,
              i == 0 ? true : false
            );
          }
        } else {
          this.isLoading = false;
        }
      } else {
        this.leaveRequestToEdit = this.getLeaveRequestSelected;
      }

      if (!this.leaveRequestToEdit) {
        this.$router.push({ name: "employee-leave" });
      }
      this.formatData();
    } catch (error) {
    } finally {
      // this.isLoading = false;
    }
  },
  data() {
    return {
      alert: {},
      options: [],
      text: null,
      leaveRequestToEdit: {},
      isLoading: true,
      moment,
      show: false,
      isDisabled: false,
      keyword: KEYWORDS.DEF_CONGES,
      tempSecondphoto: null,
      tempPhoto: "",
      uploadedFirstFile: null,
      uploadedSecondFile: null,
      fileName: "",
      fileSecondName: "",
      isShowImage: false,
      isShowSecondImage: false,
      
    };
  },
  methods: {
    ...mapActions(["getLeaveRequestStatuses", "fetchLeaveRequestType"]),
    getType(id) {
      if (this.leaveRequestToEdit) {
        const result = this.leaveRequestsTypes.find(
          (item) => item.value === id
        );
        if (result && result.text) {
          return result.text;
        }
        return this.$t("no-data");
      }
      return this.$t("no-data");
    },
    formatData() {
      this.leaveRequestToEdit.startDate = moment(
        this.leaveRequestToEdit.startDate
      ).local().format("YYYY-MM-DD");
      this.leaveRequestToEdit.endDate = moment(
        this.leaveRequestToEdit.endDate
      ).local().format("YYYY-MM-DD");
    },
    checkFileExistanceDownload(filePath, fileName, isFirst = false) {
      const vue = this;
      return downloadService
        .checkDownloadToken(
          {
            filePath: String.raw`${filePath}`,
          },
          {
            headers: {
              Accept: "application/json",
            },
          }
        )
        .then(function(response) {
          if (response.success) {
            if (!fileName) {
              fileName = filePath
                .split("/")
                .pop()
                .split(".")
                .shift();
              if (isFirst) {
                vue.fileName = fileName;
              } else {
                vue.fileSecondName = fileName;
              }
            }
            vue.downloadFromToken(response.data.token, filePath, isFirst);
          } else {
            vue.callToaster(`${vue.$t("error-download")}: ${response.message}`);
          }
        })
        .catch(function(error) {
          vue.callToaster(vue.$t("error-download") + ".");
          console.error(error);
        });
    },
    downloadFromToken(token, filePath, isFirst = false) {
      const vue = this;
      let index = isFirst ? 0 : 1;
      const extension = filePath.split(".")[1];
      let urlFile;
      downloadService
        .downloadFromToken(
          {
            token: token,
          },
          {
            headers: {
              Accept: extension,
            },
            responseType: "arraybuffer",
            dataType: "blob",
          }
        )
        .then(function(response) {
          var blob = new Blob([response], {
            type: extension,
          });

          if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(
              blob,
              "Document-Espace-Adv-Vitalliance.pdf"
            );
          } else {
            urlFile = window.URL.createObjectURL(blob);

            let showImage = false;
            showImage = false;
            if (
              filePath.includes("png") ||
              filePath.includes("gif") ||
              filePath.includes("jpeg") ||
              filePath.includes("svg")
            ) {
              showImage = true;
            }

            if (isFirst) {
              vue.tempPhoto = showImage ? urlFile : "";
              vue.uploadedFirstFile = urlFile;
            } else {
              vue.tempSecondphoto = showImage ? urlFile : "";
              vue.uploadedSecondFile = urlFile;
            }
          }

          if(vue.leaveRequestToEdit.filePath.length==(index+1)) {
            vue.isLoading = false;
          }
        })
        .catch(function(error) {
          // handle error
          vue.callToaster(vue.$t("error-download") + ".");
          console.error(error);
        });
    },
    downloadDocument(isFirst) {
      const url = isFirst ? this.uploadedFirstFile : this.uploadedSecondFile;
      const fileName = isFirst ? this.fileName : this.fileSecondName;
      var a = document.createElement("a");
      a.href = url;
      a.download = fileName + ".pdf";
      document.body.appendChild(a);
      a.click();
    },

    async deletedLeaveRequest() {
      try {
        const value = await this.$bvModal.msgBoxConfirm(
          this.$t("confirm-delete"),
          {
            title: this.$t("alert-confirm"),
            size: "md",
            buttonSize: "sm",
            okTitle: "OUI",
            okVariant: "primary",
            cancelTitle: "NON",
            cancelVariant: "primary",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        );
        if (value) {
          this.show = true;
          const res = await leaveRequests.deletedLeaveRequest(
            this.leaveRequestToEdit.pkLeaveRequest
          );
          if (res.success) {
            this.callToaster(this.$t("leave-request-deleted"));
            this.backtoList();
          } else {
            this.showErrorMessage(res);
          }
        }
      } catch (error) {
      } finally {
        this.show = false;
      }
    },
    backtoList() {
      this.$router.push({ name: "employee-leave" });
    },
    showErrorMessage(error) {
      if (error.message) {
        this.alert = {
          variant: ALERT_TYPES.DANGER,
          message: error.message,
          show: true,
        };
      }
    },
    async cancelLeaveRequest() {
      try {
        const value = await this.$bvModal.msgBoxConfirm(
          this.$t("confirm-cancel"),
          {
            title: this.$t("alert-confirm"),
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "OUI",
            cancelTitle: "NON",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        );
        if (value) {
          const res = await leaveRequests.cancelLeaveRequest(
            this.leaveRequestToEdit.pkLeaveRequest
          );
          if (res.success) {
            this.callToaster(this.$t("leave-request-canceled"));
            this.backtoList();
          } else {
            this.showErrorMessage(res);
          }
        }
      } catch (error) {}
    },
  },
};
